<template>
  <div>
    <section class="think-area responsive-content area-padding mid-top-padding">
      <div class="think-fluid">
        <div class="container">
          <div class="row mb--20">
            <div class="col-md-10">
              <div class="">
                <h4 class="">
                  Generación de reporte por robo o extravío.
                </h4>
                <p class="body-font1" v-if="onUsernameView || onFormView">
                  Al crear un reporte por robo o extravío tu cuenta quedará bloqueada para la realización de operaciones.
                  Una vez que consideres conveniente reestablecer tu cuenta, deberá transcurrir al menos un día hábil
                  para que puedas reestablecer tu cuenta y realizar operaciones.
                  Si ya tienes un reporte creado, puedes darle seguimiento en la sección
                  <router-link :to="{name: 'seguimientoReporteRoboExtravio'}" class="high-link"> Seguimiento a reporte por robo o extravío</router-link>.
                </p>
              </div><!-- end avivon-heading -->
            </div><!-- end col-md-6 -->
          </div><!-- end row -->

          <div class="row" v-if="onUsernameView">
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-12">
                  <label class="form-label">Ingresa tu correo o alias para comenzar con el proceso.</label>
                </div>
              </div>

              <div class="row mb--20">
                <div class="col-md-11">
                  <div class="input-group">
                      <input type="email" class="form-control" placeholder="Correo o alias" v-model.trim="username" v-on:keyup.enter="sendUsernameRequest">
                      <button class="subscribe-btn" :class="{disabled: isLoading}" @click.stop="sendUsernameRequest">
                        <template v-if="!isLoading">Iniciar Reporte</template>
                        <template v-if="isLoading">Verificando...</template>
                      </button>
                  </div>
                </div>
              </div>
              <div class="row" v-if="errorMssg != null">
                <div class="col-md-12 error_text">
                  <label style="color:red; margin-bottom:10px; margin-top:0;">{{errorMssg}}</label>
                </div>
              </div>
            </div>
          </div>

          <template v-if="onFormView">
            <div class="row">
              <div class="col-md-12">
                <p class="form-label">Por favor, llena los siguientes datos en base a la información cargada en tu cuenta:</p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="row" v-if="errorMssg != null">
                  <div class="col-md-12 error_text">
                    <label style="color:red; margin-bottom:10px; margin-top:0;">{{errorMssg}}</label>
                  </div>
                </div>

                <!-- Person type 0 y 4 -->
                <SLRPerson0And4
                  v-if="isPersonType0And4"
                  ref="currentForm"
                  :states="states"
                  :banks="banks" />

                <!-- Person type 1 -->
                <SLRPerson1
                  v-if="isPersonType1"
                  ref="currentForm"
                  :states="states"
                  :banks="banks" />

                <!-- Person type 2 -->
                <SLRPerson2
                  v-if="isPersonType2"
                  ref="currentForm"
                  :banks="banks" />

                <!-- Person type 3 -->
                <SLRPerson3
                  v-if="isPersonType3"
                  ref="currentForm"
                  :states="states"
                  :banks="banks" />

                <div class="row mb-3">
                  <div class="col-sm-12">
                    <vue-recaptcha
                      v-if="siteKey"
                      ref="vrecaptcha"
                      @verify="onVerify"
                      @expired="onExpired"
                      :sitekey="siteKey"></vue-recaptcha>
                  </div>
                </div>
                <div class="row before-reg mt-15px">
                  <div class="col-md-6  display-flex">
                    <button class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button m-2" @click.stop="checkForm" :class="{disabled: isLoading}">
                      <template v-if="!isLoading">Generar Reporte</template>
                      <template v-if="isLoading">Enviando...</template>
                    </button>
                    <button class="axil-btn btn-fluid btn-dark m-2" @click.stop="cancelForm" v-if="!isLoading">Cancelar</button>
                  </div>
                </div>

              </div>
            </div>
          </template>

          <template v-if="onSuccessView">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <p class="bold mb-15px mt-30px">Se ha generado el siguiente reporte por robo o extravío:</p>
                    <p class="xs-margin">Folio: <span class="bold-inline">{{reportInfo.folio}}</span></p>
                    <p class="xs-margin">Fecha de creación del reporte: <span class="bold">{{reportInfo.created_at}}</span></p>
                    <p class="mt-30px rg-description-text">
                      Guarda tu folio en un lugar seguro, ya que te lo solicitaremos para el desbloqueo de tu cuenta.
                      Si deseas dar seguimiento a tu reporte o reestablecer tu cuenta, puedes realizarlo en la sección
                      <router-link class="high-link" :to="{name: 'seguimientoReporteRoboExtravio'}">Seguimiento a reporte por robo o extravío</router-link>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>


        </div><!-- end container -->
      </div><!-- end think-fluid -->
    </section>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import SLRPerson0And4 from "@components/steal-loss-report/SLRPerson0And4";
import SLRPerson1 from "@components/steal-loss-report/SLRPerson1";
import SLRPerson2 from "@components/steal-loss-report/SLRPerson2";
import SLRPerson3 from "@components/steal-loss-report/SLRPerson3";
export default {
  name: "StealLosReportForm",
  components: {
    VueRecaptcha,
    SLRPerson0And4,
    SLRPerson1,
    SLRPerson2,
    SLRPerson3
  },
  data () {
    return {
      errorMssg: null,
      isLoading: false,
      currentView: null,
      username: null,
      siteKey: null,
      banks: [],
      states: [],
      formFields: [],
      recaptcha: null,
      userInfo: {
        user_id: null,
        person_type: null,
      },
      reportInfo: {
        folio: null,
        created_at: null,
      }
    }
  },
  created(){
    // constantes
    this.USERNAME_VIEW = 1
    this.FORM_VIEW = 2
    this.SUCCESS_VIEW = 3
  },
  beforeMount(){
    this.currentView = this.USERNAME_VIEW
    this.siteKey = process.env.VUE_APP_RECPATCHA_SITE_KEY;
  },
  computed: {
    onUsernameView() {
      return this.currentView === this.USERNAME_VIEW
    },
    onFormView(){
      return this.currentView === this.FORM_VIEW
    },
    onSuccessView(){
      return this.currentView === this.SUCCESS_VIEW
    },
    isPersonType0And4(){
      return (this.userInfo.person_type === 0 || this.userInfo.person_type === 4)
    },
    isPersonType1(){
      return this.userInfo.person_type === 1
    },
    isPersonType2(){
      return this.userInfo.person_type === 2
    },
    isPersonType3(){
      return this.userInfo.person_type === 3
    }
  },
  methods: {
    async sendUsernameRequest(){
      if(this.username != null){
        await this.doSendUsername();
      }
      else {
        this.errorMssg = "Por favor, ingresa tu correo o alias para iniciar el proceso."
      }
    },
    async doSendUsername(){
      this.errorMssg = null
      this.isLoading = true
      try {
        const payload = {user: this.username.trim()}
        const res = await this.publicApiPost('/api/compliance/ume/stealLossReport/form', payload);
        // console.log(res);
        this.banks = res.data.banks;
        this.states = res.data.states;
        this.userInfo = res.data.userInfo;
        this.formFields = res.data.fields;

        this.currentView = this.FORM_VIEW
      }
      catch (e) {
        this.errorMssg = this.catchErrorMessage(e)
      }
      this.isLoading = false
    },
    async doGenerateReport(payload){
      this.errorMssg = null
      this.isLoading = true
      try {
        payload.user_id = this.userInfo.user_id
        const res = await this.publicApiPost('/api/compliance/ume/stealLossReport/generate', payload);
        this.reportInfo = {
          folio: res.data.folio,
          created_at: res.data.created_at
        }
        this.currentView = this.SUCCESS_VIEW
      }
      catch (e) {
        this.resetRecaptcha()
        this.errorMssg = this.catchErrorMessage(e)
      }
      this.isLoading = false
    },
    async checkForm(){
      this.errorMssg = null
      const valid = this.$refs.currentForm.checkForm();
      if(valid){
        if(this.validateCaptcha()){
          let payload = this.$refs.currentForm.getPayload();
          payload.recaptcha = this.recaptcha;
          await this.doGenerateReport(payload);
        }
      }
    },
    cancelForm(){
      this.resetForm()
      this.currentView = this.USERNAME_VIEW
    },
    resetForm(){
      this.folio = null
      this.errorMssg = null
      this.username = null
      this.recaptcha = null
      this.userInfo = {
        user_id: null,
        person_type: null,
      }
    },
    catchErrorMessage(e){
      if(e && e.response && e.response.data && e.response.data.mensaje){
        return e.response.data.mensaje
      }
      else {
        return "Ha ocurrido un error con la petición, por favor intenta más tarde."
      }
    },
    validateCaptcha(){
      if(this.recaptcha == null){
        this.errorMssg = "Por favor completa la verificación 'No soy un robot'."
        return false
      }
      return true
    },
    onVerify(response){
      this.recaptcha = response;
    },
    onExpired(){
      this.recaptcha = null
    },
    resetRecaptcha(){
      this.recaptcha = null
      this.$refs.vrecaptcha.reset()
    }
  }
}
</script>

<style scoped>

</style>